import React from 'react';
import PropTypes from 'prop-types';
import { Spinner as SpinnerContainer } from './styles';

const Spinner = function ({ size, color }) {
  return (
    <SpinnerContainer size={size} color={color}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </SpinnerContainer>
  );
};

Spinner.propTypes = {
  size: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  color: PropTypes.string,
};

export default Spinner;
